// src/components/Teams/UserInfo.js
import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../firebase-config";

const UserInfo = ({ uid, isCreator = false }) => {
  const [data, setData] = useState(null);
  const [regionName, setRegionName] = useState("N/A");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const docSnap = await getDoc(doc(db, "users", uid));
        if (docSnap.exists()) {
          setData(docSnap.data());
        }
      } catch (e) {
        console.error("Error fetching user info:", e);
      }
    };
    fetchUser();
  }, [uid]);

  useEffect(() => {
    const fetchRegionName = async () => {
      if (data && data.region) {
        try {
          const regionDoc = await getDoc(doc(db, "regions", data.region));
          if (regionDoc.exists()) {
            const rdata = regionDoc.data();
            setRegionName(rdata.regionName || "N/A");
          }
        } catch (e) {
          console.error("Error fetching region info:", e);
        }
      }
    };
    fetchRegionName();
  }, [data]);

  if (!data) return <span>Loading...</span>;

  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="subtitle1">
        {data.firstName} {data.lastName} {isCreator && "(Creator)"}
      </Typography>
      <Typography variant="body2">Handicap: {data.handicap || "N/A"}</Typography>
      <Typography variant="body2">Location: {data.location || "N/A"}</Typography>
      <Typography variant="body2">Region: {regionName}</Typography>
    </Box>
  );
};

export default UserInfo;